import { useQuery, UseQueryOptions } from 'react-query';
import { AxiosRequestConfig } from 'axios';
import client from 'client';

import type { UserSearchResponse, RequestWithPagination } from './types';

type Order = 'ASC' | 'DESC';

type SortingOrders = {
    FIRST_NAME?: Order;
    LAST_NAME?: Order;
};

export enum FieldType {
    EVENT_ID = 'EVENT_ID',
    USER_PROFILE_ID = 'USER_PROFILE_ID',
    LIFECYCLE = 'LIFECYCLE',
    IS_HIDDEN = 'IS_HIDDEN',
    COMMUNITY_MULTI_MATCH = 'COMMUNITY_MULTI_MATCH',
}

type Criteria = {
    field: FieldType;
    value: number | number[] | boolean | string;
    action: string;
};

export type UsersSearchRequest = RequestWithPagination & {
    sortOrder: SortingOrders;
    criteria: (Criteria | string)[];
};

export const usersSearch = async (
    eventId: number,
    payload: UsersSearchRequest,
    config?: AxiosRequestConfig
) => {
    const response = await client().post<UserSearchResponse>(
        `api/v2/people/events/${eventId}/userSearch`,
        payload,
        config
    );

    return response.data;
};

const useUsersSearch = ({
    eventId,
    payload,
    queryKey,
    options,
}: {
    eventId: number;
    payload: UsersSearchRequest;
    queryKey: string;
    options?: UseQueryOptions<UserSearchResponse>;
}) => {
    return useQuery<UserSearchResponse>([queryKey, payload], () => usersSearch(eventId, payload), {
        ...options,
    });
};

export default useUsersSearch;
